import url from '@/utils/config';

type Props = {
  label: { open: string; close: string };
  isDisplay: boolean;
  onClick: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * 開閉状態に応じてラベルを切り替えるアコーディオン用ボタン。
 * @param props 開閉文言、表示状態、クリック処理
 * @returns アコーディオン操作ボタン
 */
const AccordionButton = ({ label, isDisplay, onClick }: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    onClick(e);
    // リンク押下時に下線が表示されないようにするため
    e.currentTarget.blur();
  };

  return (
    <div className='accordion_button' style={{ display: 'flex', justifyContent: 'right' }}>
      <a
        className='m-link'
        href=''
        // 実体はトグル操作なのでリンク遷移ではなくクリックハンドラで制御する。
        onClick={handleClick}
        data-testid='accordion_button'
        aria-expanded={isDisplay}
        role='button'
      >
        <img
          className={`m-link__img accordion_img_${isDisplay ? 'open' : 'close'}`}
          src={url('/images/icon_arrow_right.svg')}
          alt=''
        />
        {isDisplay ? label.close : label.open}
      </a>
    </div>
  );
};

export default AccordionButton;
